"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var FieldHelper = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-field__help-text"], utilityClasses);
    return react_1.default.createElement("span", { className: classes.join(" ") }, props.children);
};
var FieldGroupLayout;
(function (FieldGroupLayout) {
    FieldGroupLayout["Inline"] = "+inline";
    FieldGroupLayout["Stacked"] = "+stacked";
})(FieldGroupLayout || (FieldGroupLayout = {}));
var FieldGroup = function (props) {
    var _a;
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-field-group", (_a = props.layout) !== null && _a !== void 0 ? _a : FieldGroupLayout.Stacked], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
FieldGroup.Layout = FieldGroupLayout;
var FieldSetLayout;
(function (FieldSetLayout) {
    FieldSetLayout["Inline"] = "+inline";
    FieldSetLayout["Stacked"] = "+stacked";
    FieldSetLayout["Fill"] = "+fill";
})(FieldSetLayout || (FieldSetLayout = {}));
var FieldSet = function (props) {
    var _a;
    var legend = props.legend;
    var layoutOptions = (_a = props.layoutOptions) !== null && _a !== void 0 ? _a : [FieldSetLayout.Fill, FieldSetLayout.Inline];
    var classes = __spreadArray(__spreadArray(["c-form"], layoutOptions), distillUtilityClasses_1.default(props));
    return (react_1.default.createElement("fieldset", { className: classes.join(" ") },
        legend && react_1.default.createElement("legend", null, legend),
        props.children));
};
FieldSet.Layout = FieldSetLayout;
//# sourceMappingURL=Field.js.map